import React, { FC } from 'react';
import { Connect, PropsFromRedux } from './FolderListContainer';
import { Folder } from '../folders.types';
import styles from './folder_list.module.scss';

type Props = PropsFromRedux & {
  docId: string;
  children: (folder: Folder) => React.ReactNode;
};

export const RawFolderList: FC<Props> = ({ folders, children }) => (
  <>
    {folders.map((folder: Folder) => (
      <div
        className={`${styles.button} button-group tiny no-gaps`}
        key={folder.folderKey}
        data-cypress="folder-in-page"
      >
        {children(folder)}
      </div>
    ))}
  </>
);

export const FolderList = Connect(RawFolderList);
